import { getUserId } from '../../../../DefaultService';
import { IPaginationParams } from '../../../../types';
import { queryClient } from '../../../../../index';
import { ISchoolMonitoringEventSimpleProps } from '../../../SchoolMonitoringEventService/types';
import { ICustomerRecognitionEventSimpleProps } from '../../types';

export const CUSTOMER_RECOGNITION_EVENT_CACHE_KEY = 'customerRecognitionEvent';

const USER_ID = getUserId();

export const useCustomerRecognitionEventDataStreamCache = () => {
  return {
    getCacheData: (pagination: IPaginationParams): any[] | undefined =>
      queryClient.getQueryData<ICustomerRecognitionEventSimpleProps[]>([
        `${CUSTOMER_RECOGNITION_EVENT_CACHE_KEY}${pagination.pageNumber}`,
        pagination,
        USER_ID,
      ]),
    setCacheData: (
      data: ISchoolMonitoringEventSimpleProps[],
      pagination: IPaginationParams,
    ) =>
      queryClient.setQueryData(
        [
          `${CUSTOMER_RECOGNITION_EVENT_CACHE_KEY}${pagination.pageNumber}`,
          pagination,
          USER_ID,
        ],
        data,
      ),
    clearCacheData: () => {
      queryClient
        .getQueryCache()
        .getAll()
        .forEach(({ queryKey }) => {
          if (
            Array.isArray(queryKey) &&
            queryKey[0].startsWith(CUSTOMER_RECOGNITION_EVENT_CACHE_KEY) &&
            queryKey[2] == USER_ID
          ) {
            queryClient.removeQueries({ queryKey });
          }
        });
    },
  };
};
